'use strict';

var useTheme$1 = require('../../../../_virtual/useTheme.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
var index = require('../../../../_virtual/index.js_commonjs-proxy.js');
var React = require('react');
require('./defaultTheme.js');
var defaultTheme = require('../../../../_virtual/defaultTheme.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(useTheme$1.__exports, "__esModule", {
  value: true
});
var _default = useTheme$1.__exports.default = useTheme;

var _styles = index;

var _react = _interopRequireDefault(React__default["default"]);

var _defaultTheme = _interopRequireDefault(defaultTheme.__exports);

function useTheme() {
  var theme = (0, _styles.useTheme)() || _defaultTheme.default;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useDebugValue(theme);
  }

  return theme;
}

module.exports = _default;
